import {sendEvent} from '@github-ui/hydro-analytics'
import {Banner, Link, LinkButton, VisuallyHidden} from '@primer/react'

import {UPGRADE_FREEZE_LEARN_MORE_URL} from '../../utils/copilot-chat-helpers'
import {copilotFeatureFlags} from '../../utils/copilot-feature-flags'
import {useEntitlement} from './EntitlementContext'
import styles from './FreeChatExceededBanner.module.css'
import {useQuotaBannerImpression} from './use-quota-banner-impression'

export function FreeChatExceededBanner() {
  const {resetDate, plan, tokenBasedBillingEnabled} = useEntitlement()
  useQuotaBannerImpression({variant: 'free_chat_exceeded', source: 'copilot-chat'})
  const showFreezeMessage = copilotFeatureFlags.upgradeFreezeEnabled

  const description = (
    <>
      <VisuallyHidden>
        <h2>Limit reached</h2>
      </VisuallyHidden>
      You have reached your free plan limit. Limit resets on {resetDate}.
      {showFreezeMessage && (
        <>
          {' '}
          Plan upgrades are temporarily unavailable.{' '}
          <Link inline href={UPGRADE_FREEZE_LEARN_MORE_URL}>
            Read more
          </Link>
        </>
      )}
    </>
  )

  const primaryAction = showFreezeMessage ? undefined : (
    <LinkButton
      as="a"
      href="https://github.com/features/copilot#pricing"
      onClick={() => {
        sendEvent('dotcom_chat.activate', {
          target: 'QUOTA_BANNER_EXCEEDED',
          action: 'upgrade',
          mode: 'immersive',
          tokenBasedBillingEnabled,
          plan,
        })
      }}
    >
      Upgrade
    </LinkButton>
  )

  return (
    <div className={styles.container}>
      <Banner
        variant="upsell"
        title="Limit reached"
        description={description}
        hideTitle
        primaryAction={primaryAction}
      />
    </div>
  )
}
